module.exports = __webpack_public_path__ + "img/Animales-KU1.239797d3.png";